<template>
  <div>
    <div id="piaoju1" style="display: none;">
      <div class="hiprint-printTemplate">
        <div class="hiprint-printPanel panel-index-0" id="panel">
          <div class="hiprint-printPaper" original-height="297"
            style="width: 210mm; height: 297mm;">
            <div class="hiprint-printPaper-content">
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 210mm; height: 21pt; font-size: 18pt; font-weight: 600; letter-spacing: 2.5pt; color: rgb(41, 53, 227); text-align: center; line-height: 18pt; top: 15pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">检验申请单</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute;font-size: 12pt; width: 150pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 20pt; top: 55pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">姓名：{{info.name}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; font-size: 12pt;width: 140pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 150pt; top: 55pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">性别：{{info.dict_sex_name}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute;font-size: 12pt; width: 100pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 280pt; top: 55pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">年龄：{{info.age}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute;font-size: 12pt; width: 150pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 20pt; top: 75pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">申请科室：{{info.department}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; font-size: 12pt;width: 140pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 150pt; top: 75pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">申请时间：{{info.date}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; font-size: 12pt;width: 100pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 280pt; top: 75pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">申请医生：{{info.doctor_name}}</div>
              </div>
              <div class="hiprint-printElement hiprint-printElement-rect"
                style="border:none;border-top: 1pt solid rgb(41, 53, 227);  position: absolute; width: 210mm; height: 282pt; left: 0pt; top: 90pt;">
              </div>
              <div class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 80pt; height: 10pt; color: rgb(41, 53, 227); left: 10pt; top: 85pt;">
                <!-- <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                  style="position: absolute;font-size: 12pt; width: 150pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 20pt; top: 10pt;">
                  <div class="hiprint-printElement-text-content hiprint-printElement-content"
                    style="height:100%;width:100%">患者症状及病因：</div>
                </div>
                <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                  style="position: absolute;font-size: 12pt; width: 150mm; color: rgb(41, 53, 227); text-align: left; line-height: 15pt; left: 130pt; top: 10pt;border-bottom:1px solid rgb(41, 53, 227);">
                  <div class="hiprint-printElement-text-content hiprint-printElement-content"
                    style="height:100%;width:100%">
                    [主诉：反复水肿8年，规律透析一年余][主诉：反复水肿8年，规律透析一年余][主诉：反复水肿8年，规律透析一年余][主诉：反复水肿8年，规律透析一年余][主诉：反复水肿8年，规律透析一年余]
                  </div>
                </div> -->
                <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                  style="position: absolute; font-size: 12pt;width: 150pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 20pt; top: 30pt;">
                  <div class="hiprint-printElement-text-content hiprint-printElement-content"
                    style="height:100%;width:100%">诊断：</div>
                </div>
                <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                  style="position: absolute;font-size: 12pt; width: 150mm; color: rgb(41, 53, 227); text-align: left; line-height: 15pt; left: 130pt; top: 30pt;border-bottom:1px solid rgb(41, 53, 227);">
                  <div class="hiprint-printElement-text-content hiprint-printElement-content"
                    style="height:100%;width:100%">{{info.diagnosis_name_list}}</div>
                </div>
                <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                  style="position: absolute;font-size: 12pt; width: 150pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 20pt; top: 90pt;">
                  <div class="hiprint-printElement-text-content hiprint-printElement-content"
                    style="height:100%;width:100%">检验项目：</div>
                </div>
                <div style="position: absolute; left: 130pt; top: 90pt;">
                  <div tabindex="1" class="hiprint-printElement hiprint-printElement-text" v-for="item in info.drug_list"
                  style=" font-size: 12pt;width: 150mm; color: rgb(41, 53, 227); text-align: left; line-height: 15pt;height: 15pt; border-bottom:1px solid rgb(41, 53, 227);">
                  <div class="hiprint-printElement-text-content hiprint-printElement-content"
                    style="height:100%;width:100%;display: flex;justify-content: space-between;" ><span>{{item.drug}}</span> <span>{{item.num}}次</span></div>
                </div>
                </div>
                <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                  style="position: absolute;font-size: 12pt; width: 150pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 20pt; top: 180mm;">
                  <div class="hiprint-printElement-text-content hiprint-printElement-content"
                    style="height:100%;width:100%">总金额：{{info.total_fee}}</div>
                </div>
                <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                  style="position: absolute; font-size: 12pt;width: 300pt; color: rgb(41, 53, 227); text-align: left; line-height: 15pt; left: 150pt; top: 180mm;">
                  <div class="hiprint-printElement-text-content hiprint-printElement-content"
                    style="height:100%;width:100%">医生签名：{{info.doctor_name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { ref, onMounted,defineExpose  } from 'vue';
  const info =ref('')
  onMounted(() => {
     
  })
  const initData = (item)=>{
    info.value = item
  }
  //A4的panel设置
  const a4Panel = { width: 211, height: 297, paperFooter: 200, paperHeader: 10,paperNumberDisabled:true,'orient': 1 }
  import { autoConnect, disAutoConnect, hiprint, defaultElementTypeProvider } from 'vue-plugin-hiprint'
  // disAutoConnect()// 取消自动连接直接打印客户端
  hiprint.init()//初始化
  const print = (title) => {
    let hiprintTemplate = new hiprint.PrintTemplate()
    let panel = hiprintTemplate.addPrintPanel(a4Panel);
    panel.addPrintHtml({ options: { width: 140, height: 35, top: 10, left: 20, content: $('#piaoju1').html() } });
    //打印
    hiprintTemplate.print();
  }
  defineExpose({
    info,
    print,
    initData
  })
</script>
<style scoped>
  .patentList {
    background-color: #fff;
  }
</style>